import {
  FETCH_ALL_PARTNERS,
} from './../../mutation-types';

export default {
  [FETCH_ALL_PARTNERS](state, partners) {
    state.all = partners;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/partner/mutations.js